module.exports = __webpack_public_path__ + "img/atl.fa4948f1.jpg";